import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { styles } from '@frontend/design-system';

export const titleContainerStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(3)};
  margin-bottom: ${theme.spacing(1)};
`;

export const titleStyle = [
  styles.truncate,
  css`
    flex: 1;
  `,
];

export const headerActionsContainerStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(2)};
`;

export const estimatedTimeContainerStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(0.5)};
`;
